import state from '~store/modules/payments/state'
import actions from '~store/modules/payments/actions'

export default {
  state,
  actions
}
